import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../../../colors';
import { getDisplayColorStatusBooking } from '../../../../../utils/utils';

export const TableDetailReservationStyled = {
  TableContainer: styled(Grid)<any>`
    margin-top: 28px;
    margin-bottom: 28px;
    width: 100%;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    background-color: ${Colors.White};
    min-height: 205px;
  `,
  Header: styled(Grid)<any>`
    display: flex;
    justify-content:space-between;
  `,
  HeaderTitleContainer: styled(Grid)<any>`
    display: flex;
    flex:3;
    align-items: center;
  `,
  HeaderTitle: styled.p<any>`
    font-family: EncodeSans-Bold;
    font-size: 18px;
    margin-right: 16px;
  `,
  HeaderButtons: styled(Grid)<any>`
    display: flex;
    flex: 2;
    align-items: center;
    justify-content: space-between;
  `,
  ContentDetailsContainer: styled(Grid)<any>`
    display: flex;
    justify-content: space-between;
  `,
  ColumnDetails: styled(Grid)<any>`
    display: flex;
    flex-direction: column;
    width: 30%;
  `,
  FieldDetailContainer: styled(Grid)<any>`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  FieldDetailLabel: styled.p`
    font-size: 11px;
    padding: 7px 0px 7px 0px;
    font-family: EncodeSans-Bold;
    letter-spacing: 1px;
  `,
  FieldDetailValue: styled.p`
    font-size: 14px;
    font-family: EncodeSans-Regular;
    letter-spacing: 1px;
    word-wrap: break-word;
  `,
  ReservationStatusShape: styled.div<any>`
    border-radius: 11px;
    padding: 3px 17px 3px 18px;
    background-color: ${(props: any) => {
      return getDisplayColorStatusBooking(props.reservationStatus);
    }};
  `,
  ReservationDetails: styled(Grid)<any>`
    display: flex;
    flex-direction: column;
    padding: 26px;
  `,
  ContainerButtons: styled(Grid)<any>`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  Divider: styled.div`
    color: #dedede;
    border: solid;
    border-width: 1px;
    margin: 15px 0px 15px 0px;
  `
};
